import React from 'react';

const AuthContext = React.createContext({
    authenticatedUser: null,
    refreshUserInfo: () => { }
});

export const AuthProvider = AuthContext.Provider;
export default AuthContext;